import { render, staticRenderFns } from "./coupon-edit-rate.vue?vue&type=template&id=3254fec5"
import script from "./coupon-edit-rate.vue?vue&type=script&lang=js"
export * from "./coupon-edit-rate.vue?vue&type=script&lang=js"
import style0 from "./coupon-edit-rate.vue?vue&type=style&index=0&id=3254fec5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports